import { useEffect } from "react";
import { useLikesStore } from "../../../../common/store/likesStore";
import { apiMain } from "@/common/services";

export const useLikesData = () => {
  const setLikes = useLikesStore((state) => state.setLikes);
  const likes = useLikesStore((state) => state.likes);
  const setLoading = useLikesStore((state) => state.setLoading);
  const setFetched = useLikesStore((state) => state.setFetched);
  const isLoading = useLikesStore((state) => state.isLoading);
  const isFetched = useLikesStore((state) => state.isFetched);

  useEffect(() => {
    if (!isFetched && !isLoading) {
      (async () => {
        setLoading(true);
        try {
          const data = await apiMain.getLikedGifs();
          setLikes(data);
          setFetched(true);
        } catch (error) {
          console.warn("Error fetching likes:", error);
        } finally {
          setLoading(false);
        }
      })();
    }
  }, []);

  return { likes };
};
